<h1 class="h3 mb-2 text-gray-800">Plan de refinamiento ingresado</h1>

<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Formulario de Plan de Tratamiento</h6>
    </div>
    <div class="card-body">
        <form>
            <app-planform [archivos]="archivos" [isAdmin]="isAdmin" [editable]="false" [isRefinamiento]="true"
                [planForm]="refinamiento"></app-planform>
                <div class="row">
                    <div class="col-4 offset-4">
                        <div class="form-group" *ngIf="archivoExiste('foto-superior')">
                            <label>
                                Foto Superior
                            </label>
                            <div>
                                <a class="caso-foto" href="{{getImageUrl('foto-superior')}}" target="_blank"><img
                                        src="{{getImageUrl('foto-superior')}}" /></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <div class="form-group" *ngIf="archivoExiste('foto-derecha')">
                            <label>Foto Lateral Der</label>
                            <div>
                                <a class="caso-foto" href="{{getImageUrl('foto-derecha')}}" target="_blank"><img
                                        src="{{getImageUrl('foto-derecha')}}" /></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="form-group" *ngIf="archivoExiste('frente-intraoral')">
                            <label>Frente Intraoral</label>
                            <div>
                                <a class="caso-foto" href="{{getImageUrl('frente-intraoral')}}" target="_blank"><img
                                        src="{{getImageUrl('frente-intraoral')}}" /></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="form-group" *ngIf="archivoExiste('foto-izquierda')">
                            <label>Foto Lateral Izq</label>
                            <div>
                                <a class="caso-foto" href="{{getImageUrl('foto-izquierda')}}" target="_blank"><img
                                        src="{{getImageUrl('foto-izquierda')}}" /></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4 offset-4">
                        <div class="form-group" *ngIf="archivoExiste('foto-inferior')">
                            <label>Foto Inferior</label>
                            <div>
                                <a class="caso-foto" href="{{getImageUrl('foto-inferior')}}" target="_blank"><img
                                        src="{{getImageUrl('foto-inferior')}}" /></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <div class="form-group" *ngIf="archivoExiste('frente-facial')">
                            <label>Frente Facial</label>
                            <div>
                                <a class="caso-foto" href="{{getImageUrl('frente-facial')}}" target="_blank"><img
                                        src="{{getImageUrl('frente-facial')}}" /></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="form-group" *ngIf="archivoExiste('frente-facial-sonrisa')">
                            <label>Frente Facial Sonrisa</label>
                            <div>
                                <a class="caso-foto" href="{{getImageUrl('frente-facial-sonrisa')}}"
                                    target="_blank"><img src="{{getImageUrl('frente-facial-sonrisa')}}" /></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="form-group" *ngIf="archivoExiste('perfil-facial')">
                            <label>Perfil facial</label>
                            <div>
                                <a class="caso-foto" href="{{getImageUrl('perfil-facial')}}" target="_blank"><img
                                        src="{{getImageUrl('perfil-facial')}}" /></a>
                            </div>
                        </div>
                    </div>
                </div>
        </form>
    </div>
</div>